import { GlobalService } from '@23degrees/shared/services/global';
import { EnvironmentProviders, ErrorHandler, inject, isDevMode, provideAppInitializer, provideEnvironmentInitializer, Provider } from '@angular/core';
import { Router } from '@angular/router';
import { version } from '@env/version';
import * as Sentry from '@sentry/angular';

const SENTRY_DEFAULT_OPTIONS = {
  dsn: 'https://b0488593f03dc33cefd73c00c1e8a316@sentry.23d.gr/2',
  integrations: [
    // Sentry.browserTracingIntegration(),
    // Sentry.captureConsoleIntegration({ levels: ['log', 'info', 'warn', 'error', 'debug', 'assert'] }),
    // Sentry.replayIntegration({
    //   maskAllText: false,
    //   blockAllMedia: false,
    // }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/(app|doh|pre|next)\.23degrees\.(eu|io)\/api/],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: `23frontend@${version.branch}-#${version.revision.substring(0, 7)}`, // TODO auto update this
  environment: 'next', // TODO auto update this
  tunnel: '/api/v3/tunnel/sentry',
  initialScope: {
    tags: {
      devMode: isDevMode(),
    },
  },
};

const SENTRY_PROVIDERS = [
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({
      showDialog: false,
    }),
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  // provideAppInitializer(() => inject(Sentry.TraceService)),
];

export const provideSentry = (enabled = false, options?: Sentry.BrowserOptions): Array<Provider | EnvironmentProviders> => {
  if (!enabled) {
    return [];
  }

  return [
    ...SENTRY_PROVIDERS,
    provideEnvironmentInitializer(() => {
      const globalService = inject(GlobalService);

      if (globalService.isBrowser() && !globalService.isApp()) {
        try {
          const sentrySettings = Object.assign({}, SENTRY_DEFAULT_OPTIONS, options);
          Sentry.init(sentrySettings);
          console.log('[sentry] initialized');
          inject(Sentry.TraceService);
        } catch (error) {
          console.log('[sentry] error', error);
        }
      }
    }),
  ];
};
